/**
 * Yetenekler iki yerde kullanılır:
 *  - Agent kendini tanıtırken hangi işleri yapabildiğini bildirir (`hello.capabilities`).
 *  - Job tanımı hangi yeteneği gerektirdiğini söyler.
 * Sunucu, job'ı yalnızca gereken yeteneğe sahip agent'a teklif eder.
 * Böylece PC agent'ı `systemctl` çağıramaz, VPS agent'ı build alamaz.
 */
export const CAPABILITIES = [
    // --- Yerel PC agent'ı ---
    "build.gradle", // android/gradlew ile yerel derleme
    "build.eas", // eas build (bulut) — opsiyonel yol
    "ota.publish", // eas update
    "web.deploy", // expo export + wrangler pages deploy / rsync
    "play.publish", // Google Play androidpublisher API
    "git", // durum, bump commit, push
    "dev.server", // uzun ömürlü dev sunucusu (process job)
    "adb", // cihaz/emülatör işleri
    // Discord bot deploy'u PC'dedir: kaynak dosyalar burada, VPS'e ssh2 fastPut ile
    // gönderilir ve aynı SSH oturumundan pm2 restart edilir.
    "sftp.deploy",
    "store.assets", // Play mağaza görselleri: web derlemesinden çekim + şablondan üretim (Playwright)
    // --- VPS agent'ı ---
    "service.ops", // systemctl start/stop/restart/status/journal
    "pm2.ops", // pm2 list/restart/logs
    "bot.control", // Discord bot admin ucu (yalnız 127.0.0.1'den erişilir)
    "db.query", // gwrctl / moviePort PG üzerinde tanımlı sorgular
    "backup.verify", // pg_dump + R2 tazelik kontrolü
    "host.metrics", // disk/RAM/yük
];
/** Agent türleri ve varsayılan yetenek kümeleri. */
export const AGENT_KINDS = ["pc", "vps"];
export const DEFAULT_CAPABILITIES = {
    pc: [
        "build.gradle",
        "build.eas",
        "ota.publish",
        "web.deploy",
        "play.publish",
        "git",
        "dev.server",
        "adb",
        "sftp.deploy",
        "store.assets",
    ],
    vps: [
        "service.ops",
        "pm2.ops",
        "bot.control",
        "db.query",
        "backup.verify",
        "host.metrics",
    ],
};
//# sourceMappingURL=capabilities.js.map